// extracted by mini-css-extract-plugin
export default {"overlay":"ImagePreview_overlay__EBBa8"};